function polar(cx, cy, r, angle) {

    const rad = angle * Math.PI / 180;

    return {
        x: cx + r * Math.cos(rad),
        y: cy + r * Math.sin(rad)
    };

}

function buildRoads() {

    document.querySelectorAll(".exxtra-road-segment").forEach(segment => {

        const path = segment.querySelector(".road-path");

        if (!path) return;

        const radius = Number(segment.dataset.radius);

        const curveType = segment.dataset.curveType || "u";

        let degrees = Number(segment.dataset.degrees);

        const direction = segment.dataset.direction;

        if (direction === "anticlockwise") {
            degrees *= -1;
        }

        const cx = 350;
        const cy = 350;

        const heading =
            Number(segment.dataset.rotationMajor) +
            Number(segment.dataset.rotationFine);

        const startAngle = heading - 90;
        const endAngle = startAngle + degrees;

        const start = polar(cx, cy, radius, startAngle);
        const end = polar(cx, cy, radius, endAngle);

        const largeArc = Math.abs(degrees) > 180 ? 1 : 0;
        const sweepFlag = degrees > 0 ? 1 : 0;

        // ==========================
        // U CURVE
        // ==========================

        if (curveType === "u") {

            path.setAttribute(
                "d",
                `
                M ${start.x} ${start.y}
                A ${radius} ${radius}
                0
                ${largeArc}
                ${sweepFlag}
                ${end.x} ${end.y}
                `
            );

        }

        // ==========================
        // S CURVE
        // ==========================

        else {

            const tangent = radius * 1.2;

            const startRad = startAngle * Math.PI / 180;
            const endRad = endAngle * Math.PI / 180;

            const cp1 = {
                x: start.x - Math.sin(startRad) * tangent,
                y: start.y + Math.cos(startRad) * tangent
            };

            const cp2 = {
                x: end.x + Math.sin(endRad) * tangent,
                y: end.y - Math.cos(endRad) * tangent
            };

            path.setAttribute(
                "d",
                `
                M ${start.x} ${start.y}
                C
                ${cp1.x} ${cp1.y},
                ${cp2.x} ${cp2.y},
                ${end.x} ${end.y}
                `
            );

        }

    });

}

document.addEventListener("DOMContentLoaded", buildRoads);
document.addEventListener("shopify:section:load", buildRoads);
document.addEventListener("shopify:block:select", buildRoads);
document.addEventListener("shopify:block:move", buildRoads);
document.addEventListener("shopify:block:deselect", buildRoads);
document.addEventListener("shopify:block:remove", buildRoads);

function buildHeroCarousels() {

    document.querySelectorAll('[data-carousel-v2]').forEach(function (carousel) {

        if (carousel.dataset.carouselInitialized === 'true') return;

        const slides = carousel.querySelectorAll(
            '.exxtra-hero__carousel-slide'
        );

        const dots = carousel.querySelectorAll(
            '.exxtra-hero__carousel-dot'
        );

        if (slides.length <= 1) return;

        carousel.dataset.carouselInitialized = 'true';

        let currentIndex = 0;
        let autoplayTimer = null;

        const autoplay = carousel.dataset.autoplay === 'true';
        const speed = parseInt(carousel.dataset.speed, 10) || 5000;


        function showSlide(index) {

            if (index < 0) {
                index = slides.length - 1;
            }

            if (index >= slides.length) {
                index = 0;
            }

            currentIndex = index;

            slides.forEach(function (slide, i) {

                slide.classList.toggle(
                    'is-active',
                    i === currentIndex
                );

            });

            dots.forEach(function (dot, i) {

                const active = i === currentIndex;

                dot.classList.toggle(
                    'is-active',
                    active
                );

                dot.setAttribute(
                    'aria-selected',
                    active ? 'true' : 'false'
                );

            });

        }


        function nextSlide() {
            showSlide(currentIndex + 1);
        }


        function previousSlide() {
            showSlide(currentIndex - 1);
        }


        function stopAutoplay() {

            if (autoplayTimer) {

                clearInterval(autoplayTimer);

                autoplayTimer = null;

            }

        }


        function startAutoplay() {

            if (!autoplay) return;

            stopAutoplay();

            autoplayTimer = setInterval(
                nextSlide,
                speed
            );

        }


        dots.forEach(function (dot) {

            dot.addEventListener('click', function () {

                const index = parseInt(
                    dot.dataset.slideTo,
                    10
                );

                showSlide(index);

                startAutoplay();

            });

        });


        carousel.addEventListener(
            'mouseenter',
            stopAutoplay
        );

        carousel.addEventListener(
            'mouseleave',
            startAutoplay
        );


        let touchStartX = 0;
        let touchEndX = 0;


        carousel.addEventListener(
            'touchstart',
            function (event) {

                touchStartX =
                    event.changedTouches[0].screenX;

                stopAutoplay();

            },
            { passive: true }
        );


        carousel.addEventListener(
            'touchend',
            function (event) {

                touchEndX =
                    event.changedTouches[0].screenX;

                const difference =
                    touchStartX - touchEndX;

                if (Math.abs(difference) >= 50) {

                    if (difference > 0) {
                        nextSlide();
                    } else {
                        previousSlide();
                    }

                }

                startAutoplay();

            },
            { passive: true }
        );


        showSlide(0);

        startAutoplay();

    });

}


document.addEventListener(
    'DOMContentLoaded',
    buildHeroCarousels
);

document.addEventListener(
    'shopify:section:load',
    buildHeroCarousels
);